import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/hockey';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-69" data-mp="e3didugelir3">
      <div className="mx-auto max-w-6xl" data-id="element-70" data-mp="9mhfagqn76z">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-71" data-mp="58z5fyjcikb5">
          <div className="lg:col-span-7" data-id="element-72" data-mp="574jcgwc8m5h">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-73" data-mp="3mguiw1ojetxq">The HOCKEY READY™ Difference</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-74" data-mp="3rgp7tzor59g5">
              From Stressed Coach to <em className="text-red-700" data-id="element-75" data-mp="3diqxr6hgrz6g">Confident and Prepared.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-76" data-mp="3ihv65uwkdsvq">
            Most field hockey resources talk to the player. HOCKEY READY™ is built for the coach.
            Imagine starting the week with your practices already planned — warm-ups, drills, timing,
            and coaching points ready to go.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-77" data-mp="1f8irdyd8d6b2">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-78" data-mp="1t0gtvqcfs3y9" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-79" data-mp="10bjbzoc50961">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-80" data-mp="wb7q6881g2sz">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-81" data-mp="1aba4xll1ug40">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-82" data-mp="15bnrpc580zv7">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-83" data-mp="2lpdy4pjtc080">Before HOCKEY READY™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-84" data-mp="2gqjgvs1hujq0">
              Does This Sound Familiar?
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-85" data-mp="2oqphyhkfeh6a">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-86" data-mp="2sr145ysfspjv">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-87" data-mp="2xq47nesrqnpq" />
                  <span data-id="element-88" data-mp="32onvjkqxa9kq">
                    <span className="block font-semibold text-slate-900/80" data-id="element-89" data-mp="253jd65gzxvhy">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-90" data-mp="2f0xk9eh157xl">
            <p className="text-sm font-semibold text-red-300" data-id="element-91" data-mp="2jt7hlfkh5a9w">With HOCKEY READY™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-92" data-mp="1mda183veqpd2">
              Plan Less. Coach More.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-93" data-mp="1raa9mlfqc47c">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-94" data-mp="1jrkjqdciv1yf">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-95" data-mp="1er6a4qv9vjya">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-96" data-mp="14v39jpg2jtdg" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-97" data-mp="w318pq238b2n">
          Focus on your players — instead of planning every practice yourself.
        </p>
      </div>
    </section>;
}